export interface ArticleContent {
  id: string;
  title: string;
  slug: string;
  thumbnail: string;
  duration: string;
  category: string;
  categorySlug: string;
  views: string;
  rating: string;
  publishDate: string;
  author: string;
  tags: string[];
  summary: string;
  content: ArticleSection[];
  faq: FaqItem[];
  relatedVideos: RelatedVideo[];
}

export interface ArticleSection {
  heading: string;
  text: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface RelatedVideo {
  title: string;
  slug: string;
  thumbnail: string;
  duration: string;
  category: string;
}

export const articleData: Record<string, ArticleContent> = {
  "liulang-diqiu-3": {
    id: "v001",
    title: "流浪地球3：星际远征",
    slug: "liulang-diqiu-3",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20spaceship%20approaching%20a%20massive%20ring-shaped%20space%20station%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20deep%20space%20background%20with%20stars%2C%20warm%20orange%20and%20gold%20accents%2C%20high%20contrast%2C%20movie%20poster%20style&width=1280&height=720&seq=article-detail-001&orientation=landscape",
    duration: "02:28:15",
    category: "电影",
    categorySlug: "dianying",
    views: "1280万",
    rating: "9.2",
    publishDate: "2026-07-28",
    author: "影视编辑部",
    tags: ["科幻", "冒险", "国产大片", "郭帆", "吴京"],
    summary: "人类面临前所未有的星际危机，一支由精英宇航员组成的远征队踏上未知旅程，探索新的宜居星球。本片是流浪地球系列的第三部，延续了前两部的宏大世界观与感人故事线，在视觉效果与情感深度上再次突破。",
    content: [
      {
        heading: "剧情简介",
        text: "在流浪地球计划持续推进的背景下，地球已经离开太阳系进入星际空间。然而，前方探测到一处异常引力区域，可能对整个计划造成致命威胁。由刘培强之子刘启率领的新一代宇航员团队，奉命驾驶最先进的星际飞船「天问号」，前往未知星域进行探测。在这次充满危险与未知的远征中，他们不仅面临来自宇宙的极端环境挑战，还要应对内部的分歧与抉择。",
      },
      {
        heading: "视觉特效再升级",
        text: "流浪地球3在视觉效果上实现了质的飞跃。制作团队采用了最新的虚拟制片技术，结合实景搭建与CGI特效，打造出令人惊叹的宇宙场景。从浩瀚的星云到神秘的虫洞，从巨大的空间站到精密的飞船内部，每一个画面都经过精心打磨。特别是影片中的引力异常区域场景，其视觉呈现被国际影评人誉为「科幻电影的新标杆」。",
      },
      {
        heading: "演员阵容与表演",
        text: "本片集结了国内顶尖演员阵容。吴京继续饰演刘培强，以更加成熟内敛的表演展现了一位父亲与领航者的双重身份。新生代演员易烊千玺加盟饰演年轻的宇航员林一，为影片注入新鲜活力。此外，李雪健、刘德华等实力派演员的特别出演，也为影片增色不少。",
      },
      {
        heading: "主题深度",
        text: "超越前两部的个人英雄主义叙事，流浪地球3更深入地探讨了人类命运共同体这一宏大主题。在面临全人类危机时，不同国家、不同文化背景的人如何放下分歧、携手合作？影片用震撼的视听语言，传达出关于希望、牺牲与团结的永恒命题。",
      },
    ],
    faq: [
      {
        question: "流浪地球3是流浪地球系列的最终章吗？",
        answer: "据导演郭帆透露，流浪地球3并非系列终点，而是开启了一个全新的叙事篇章。流浪地球宇宙将继续扩展，未来可能会有更多衍生作品推出。",
      },
      {
        question: "流浪地球3在哪里可以观看？",
        answer: "流浪地球3目前正在全国各大院线热映中，您也可以在本站观看高清预告片和相关花絮内容。电影数字版预计将在上映后三个月内上线各大视频平台。",
      },
      {
        question: "这部电影适合儿童观看吗？",
        answer: "电影包含一些紧张刺激的太空场景，建议8岁以上儿童在家长陪同下观看。影片整体传递积极向上的价值观，适合全家观影。",
      },
    ],
    relatedVideos: [
      { title: "长安风云录", slug: "changan-fengyunlu", thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20traditional%20architecture%2C%20ornate%20costumes%2C%20warm%20candlelight&width=320&height=180&seq=related-002&orientation=landscape", duration: "45:30", category: "电视剧" },
      { title: "星际猎人：暗影纪元", slug: "xingji-lieren", thumbnail: "https://readdy.ai/api/search-image?query=Anime%20style%20sci-fi%20scene%20with%20futuristic%20bounty%20hunter%20in%20neon-lit%20cyberpunk%20city&width=320&height=180&seq=related-004&orientation=landscape", duration: "24:00", category: "动漫" },
      { title: "蓝色星球：深海秘境", slug: "lanse-xingqiu", thumbnail: "https://readdy.ai/api/search-image?query=Stunning%20underwater%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20diverse%20marine%20life&width=320&height=180&seq=related-005&orientation=landscape", duration: "52:10", category: "纪录片" },
    ],
  },
  "changan-fengyunlu": {
    id: "v002",
    title: "长安风云录",
    slug: "changan-fengyunlu",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20traditional%20architecture%2C%20ornate%20costumes%2C%20warm%20candlelight%2C%20historical%20Tang%20dynasty%20setting%2C%20cinematic%20lighting%2C%20rich%20red%20and%20gold%20color%20palette&width=1280&height=720&seq=article-detail-002&orientation=landscape",
    duration: "45:30",
    category: "电视剧",
    categorySlug: "dianshiju",
    views: "980万",
    rating: "8.9",
    publishDate: "2026-07-25",
    author: "剧集编辑部",
    tags: ["古装", "权谋", "爱情", "唐朝", "历史"],
    summary: "以唐朝长安城为背景，讲述一段跨越三代的权谋与爱情故事。本剧以其精湛的制作水准和扣人心弦的剧情，成为年度最受瞩目的古装巨制。",
    content: [
      {
        heading: "故事背景",
        text: "长安风云录以唐玄宗天宝年间为历史背景，讲述了长安城内三大世家之间的恩怨情仇。从朝堂权谋到市井烟火，从金戈铁马到儿女情长，全景式展现了盛唐时期的繁华与危机。故事跨越三代人的命运交织，以小人物的视角折射大时代的风云变幻。",
      },
      {
        heading: "制作水准",
        text: "本剧投资超过5亿，在服化道方面精益求精。服装团队参考了大量唐代壁画和出土文物，手工制作超过3000套戏服。场景方面，剧组在横店影视城搭建了1:1还原的唐代长安街市，总面积超过10万平方米，力求为观众呈现最真实的大唐风貌。",
      },
      {
        heading: "演员阵容",
        text: "本剧由陈道明、刘亦菲领衔主演，汇聚了张译、周迅、雷佳音等实力派演员。陈道明饰演的宰相李林甫气场全开，刘亦菲饰演的女主角杨玉环惊艳全场。老中青三代演员同台飙戏，将每个角色的复杂性演绎得淋漓尽致。",
      },
    ],
    faq: [
      {
        question: "长安风云录有多少集？",
        answer: "长安风云录全剧共48集，目前正在热播中，每日更新2集。VIP会员可提前观看6集。",
      },
      {
        question: "这部剧是历史正剧还是架空创作？",
        answer: "长安风云录基于真实历史背景创作，主要事件和人物都有历史依据，但在具体情节上进行了一定的艺术加工和戏剧化处理，属于历史传奇剧的范畴。",
      },
    ],
    relatedVideos: [
      { title: "武林外传：新篇章", slug: "wulin-waizhuan-xin", thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20comedy%20drama%20scene%20in%20traditional%20inn%20setting&width=320&height=180&seq=related-008&orientation=landscape", duration: "42:30", category: "电视剧" },
      { title: "流浪地球3：星际远征", slug: "liulang-diqiu-3", thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20spaceship%20approaching%20a%20massive%20ring-shaped%20space%20station&width=320&height=180&seq=related-001b&orientation=landscape", duration: "02:28:15", category: "电影" },
    ],
  },
  "jixian-tiaozhan": {
    id: "v003",
    title: "极限挑战：荒野求生季",
    slug: "jixian-tiaozhan",
    thumbnail: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20reality%20show%20scene%2C%20group%20of%20people%20in%20dense%20forest%2C%20warm%20sunlight%20through%20trees%2C%20excitement%20and%20teamwork%2C%20cinematic%20photography&width=1280&height=720&seq=article-detail-003&orientation=landscape",
    duration: "01:35:20",
    category: "综艺",
    categorySlug: "zongyi",
    views: "1560万",
    rating: "9.5",
    publishDate: "2026-07-30",
    author: "综艺编辑部",
    tags: ["真人秀", "户外", "明星", "冒险", "团队"],
    summary: "六位明星嘉宾被空降到无人荒野，在极限环境中展开为期七天的生存挑战。本季节目以其真实感和不可预测性，创造了综艺节目收视新纪录。",
    content: [
      {
        heading: "节目形式",
        text: "极限挑战荒野求生季采用全新的「零物资」模式——嘉宾们被空降到原始森林中，除了最基本的摄制设备外，不带任何食物、饮水或工具。他们需要依靠团队协作和野外生存技能，在7天内穿越100公里的荒野到达终点。途中设置有多个挑战关卡，完成挑战可以获得生存物资奖励。",
      },
      {
        heading: "嘉宾阵容",
        text: "本季六位常驻嘉宾分别是黄渤、孙红雷、王迅、迪丽热巴、王一博和白敬亭。新老成员的碰撞产生了令人意想不到的化学反应。黄渤作为团队核心展现出超强的领导力与生存智慧，而王一博则凭借年轻人的体力和勇气多次完成高难度挑战。",
      },
      {
        heading: "精彩看点",
        text: "节目最大看点在于其完全不可预测的真实性。没有剧本、没有安排，所有反应都是嘉宾的真实表现。从与毒蛇的惊险遭遇，到深夜篝火旁的真心话环节，从饥饿时的团队分歧，到最终克服困难时的相拥而泣——每一个瞬间都直击人心。",
      },
    ],
    faq: [
      {
        question: "极限挑战荒野求生季是直播还是录播？",
        answer: "节目采用录播形式，但全程采用多机位跟拍，后期剪辑最大程度保留了现场的真实感。制作团队表示，70%以上的素材都是未经干预的真实记录。",
      },
      {
        question: "嘉宾们在野外真的没有保护措施吗？",
        answer: "节目组配备了专业的野外生存教练和医疗团队全程跟随，确保嘉宾的安全。虽然生存挑战是真实的，但安全保障同样完善。",
      },
    ],
    relatedVideos: [
      { title: "密室大逃亡第五季", slug: "mishi-taowang-5", thumbnail: "https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20setting%20with%20dim%20warm%20lighting%2C%20puzzle%20elements&width=320&height=180&seq=related-007&orientation=landscape", duration: "01:20:15", category: "综艺" },
      { title: "歌手2026：巅峰之夜", slug: "geshou-2026", thumbnail: "https://readdy.ai/api/search-image?query=Grand%20music%20concert%20stage%20with%20singer%20performing%2C%20dramatic%20spotlight&width=320&height=180&seq=related-012&orientation=landscape", duration: "02:10:45", category: "音乐" },
    ],
  },
  "xingji-lieren": {
    id: "v004",
    title: "星际猎人：暗影纪元",
    slug: "xingji-lieren",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20style%20sci-fi%20scene%20with%20futuristic%20bounty%20hunter%20in%20neon-lit%20cyberpunk%20city%2C%20dramatic%20action%20pose%2C%20vibrant%20warm%20neon%20orange%20and%20pink%20accents&width=1280&height=720&seq=article-detail-004&orientation=landscape",
    duration: "24:00",
    category: "动漫",
    categorySlug: "dongman",
    views: "820万",
    rating: "9.1",
    publishDate: "2026-07-22",
    author: "动漫编辑部",
    tags: ["科幻", "动作", "日漫", "赛博朋克", "冒险"],
    summary: "在未来星际时代，一名赏金猎人在各大星球间追捕逃犯，揭开隐藏在暗影中的惊天阴谋。本作为年度最受期待的科幻动画，制作精良，世界观宏大。",
    content: [
      {
        heading: "世界观设定",
        text: "故事设定在公元2457年，人类已经建立了横跨银河系的星际联邦。然而联邦成立后不久便陷入腐败与混乱，各星球之间贫富差距巨大。在这种背景下，赏金猎人成为一种灰色职业，他们游走在法律边缘，接受各种委托追捕逃犯。",
      },
      {
        heading: "主角介绍",
        text: "主角凯恩·雷是一位前联邦特工，因一起神秘事件被陷害而离开联邦，转行成为赏金猎人。他拥有一艘改装过的星际飞船「暗影号」，以及一套先进的战斗装甲。凯恩性格冷漠但内心正义，在追捕逃犯的过程中，他逐渐发现每一条线索都指向一个更大的阴谋。",
      },
      {
        heading: "制作团队",
        text: "本作由日本顶级动画制作公司Production I.G与国内动画工作室联合制作，导演是曾执导《攻壳机动队》系列的神山健治。音乐由菅野洋子操刀，配乐融合了电子与交响乐元素，营造出独特的未来感与紧张氛围。",
      },
    ],
    faq: [
      {
        question: "星际猎人一共有多少集？",
        answer: "星际猎人：暗影纪元第一季共24集，每周六更新1集。目前已确定将制作第二季，预计2027年播出。",
      },
      {
        question: "这部动画有中文配音吗？",
        answer: "有的，本站提供原版日语配音和中文字幕，以及国语配音两个版本，您可以根据喜好自由切换。",
      },
    ],
    relatedVideos: [
      { title: "赛博朋克：边境行者", slug: "cyberpunk-bianjing", thumbnail: "https://readdy.ai/api/search-image?query=Cyberpunk%20anime%20scene%20with%20robotic%20character%20in%20dystopian%20future%20city&width=320&height=180&seq=related-009&orientation=landscape", duration: "25:15", category: "动漫" },
      { title: "流浪地球3：星际远征", slug: "liulang-diqiu-3", thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20spaceship%20approaching%20a%20massive%20ring-shaped%20space%20station&width=320&height=180&seq=related-001b2&orientation=landscape", duration: "02:28:15", category: "电影" },
    ],
  },
  "mishi-taowang-5": {
    id: "v007",
    title: "密室大逃亡第五季",
    slug: "mishi-taowang-5",
    thumbnail: "https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20setting%20with%20dim%20warm%20lighting%2C%20puzzle%20elements%2C%20team%20of%20people%20solving%20clues%2C%20suspenseful%20atmosphere&width=1280&height=720&seq=article-detail-007&orientation=landscape",
    duration: "01:20:15",
    category: "综艺",
    categorySlug: "zongyi",
    views: "890万",
    rating: "8.7",
    publishDate: "2026-08-01",
    author: "综艺编辑部",
    tags: ["密室", "推理", "明星", "悬疑"],
    summary: "全新一季密室挑战升级，明星嘉宾需要在限定时间内破解重重机关，逃出神秘密室。新增的恐怖元素与高科技机关让节目更加刺激精彩。",
    content: [
      {
        heading: "本季升级",
        text: "第五季密室大逃亡在场景设计和谜题难度上全面升级。节目组邀请了国际知名的密室设计师团队，打造了8个主题各异的超级密室。从古墓探险到未来实验室，从诡异医院到深海基地，每个密室都拥有独特的氛围和机关系统。",
      },
      {
        heading: "嘉宾阵容",
        text: "本季常驻嘉宾包括杨幂、邓伦、黄明昊、郭麒麟和大张伟，另有每期一位飞行嘉宾加入。嘉宾们在密室内各显神通——杨幂以敏锐的观察力著称，邓伦则是逻辑推理担当，而大张伟的幽默感总能在紧张时刻缓解气氛。",
      },
    ],
    faq: [
      {
        question: "密室大逃亡的谜题是提前告知嘉宾的吗？",
        answer: "不是的。所有谜题和机关对嘉宾来说都是完全未知的，他们的所有反应和解题过程都是真实的。这也是节目最大的魅力所在。",
      },
    ],
    relatedVideos: [
      { title: "极限挑战：荒野求生季", slug: "jixian-tiaozhan", thumbnail: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20reality%20show%20scene%2C%20group%20of%20people%20in%20dense%20forest&width=320&height=180&seq=related-003b&orientation=landscape", duration: "01:35:20", category: "综艺" },
    ],
  },
};